import { createStyles } from '@material-ui/core';

export default () => createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '50px',
    height: '100%',
  },
  contentContainer: {
    marginTop: '20px',
    height: 'calc(100vh - 150px)',
  },
  rightColumn: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  rightColumnItem: {
    height: '50%',
    overflow: 'hidden',
    padding: 4,
  },
});
